import { cilDelete, cilFilter, cilReload } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CCollapse,
  CMultiSelect,
  CRow,
  CTooltip,
} from '@coreui/react-pro'
import React, { useCallback, useState } from 'react'
import DefaultSearch from './DefaultSearch'

const TableSearch = (props) => {
  const {
    children,
    onColumnManagerChange,
    defaultColumns,
    onClear,
    sortBy,
    handleSearchChange,
    searchParams,
    disableDefaultSearch,
    gridSize,
    details,
    onSubmit,
    t,
  } = props
  const [visible, setVisible] = useState(false)

  const optionsForMultiSelect = useCallback(
    (columns) =>
      columns?.map((column) => ({
        value: column.key,
        text: column.label,
        selected: column.selected === 0 ? 0 : 1,
        disabled: column.disabled,
      })),
    [],
  )

  return (
    <>
      <CRow className="align-items-center">
        {details && <CCol>{details}</CCol>}
        <CCol className="gap-3 d-flex justify-content-end my-3 me-3">
          <CCol className="maxW-14">
            <CMultiSelect
              options={optionsForMultiSelect(defaultColumns)}
              selectionType="counter"
              onChange={onColumnManagerChange}
              selectionTypeCounterText={t('columns-selected', { ns: 'common' })}
              className="float-end"
              optionsMaxHeight={222}
            />
          </CCol>
          {onSubmit && (
            <>
              <CTooltip content={t('reload', { ns: 'common' })}>
                <CButton color="light" shape="pill" className="float-end" onClick={onSubmit}>
                  <CIcon icon={cilReload} />
                </CButton>
              </CTooltip>
              <CTooltip content={t('reset', { ns: 'common' })}>
                <CButton color="light" shape="pill" className="float-end" onClick={onClear}>
                  <CIcon icon={cilDelete} />
                </CButton>
              </CTooltip>
            </>
          )}
          <CTooltip content={t('filters', { ns: 'common' })}>
            <CButton
              color="light"
              shape="pill"
              className="float-end"
              onClick={() => setVisible(!visible)}
            >
              <CIcon icon={cilFilter} />
            </CButton>
          </CTooltip>
        </CCol>
      </CRow>
      <CCollapse visible={visible}>
        <CCard className="mb-4">
          <CCardHeader>
            <h6>{t('search', { ns: 'common' })}</h6>
          </CCardHeader>
          <CCardBody>
            <CRow>
              {children}
              {!disableDefaultSearch && (
                <DefaultSearch
                  searchParams={searchParams}
                  handleSearchChange={handleSearchChange}
                  sortBy={sortBy}
                  gridSize={gridSize}
                  t={t}
                />
              )}
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CRow>
              <CCol className="my-2">
                <CButton className="float-end" type="submit" onClick={() => setVisible(!visible)}>
                  {t('search', { ns: 'common' })}
                </CButton>
                <CButton onClick={onClear} color="secondary">
                  {t('reset', { ns: 'common' })}
                </CButton>
              </CCol>
            </CRow>
          </CCardFooter>
        </CCard>
      </CCollapse>
    </>
  )
}

export default TableSearch
